module.exports = __webpack_public_path__ + "img/img4.b5fe1e7d.jpg";